import React from 'react';
import LazyImage from './LazyImage';

class WorkVisualsList extends React.Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(this.props.assets !== nextProps.assets || this.props.activeIndex !== nextProps.activeIndex) {
            return true;
        }
        
        return false;
    }

    render() {
        return (
            <div className="work-visuals" style={{transform: `rotate(${this.props.rotation}deg`}}>
                {this.props.assets.map((image, index) => {

                    let ref = React.createRef();
                    let params = {
                        src: image.medium[1].src,
                        className: image.class || '',
                        // srcSet: `${image.src.replace('.jpg', '-m.jpg')} 438w, ${image.src} 875w, ${image.src.replace('.jpg', '@2x.jpg')} 1750w`,
                        srcSet: `${image.medium[1].src} ${image.medium[1].width}w, ${image.medium[0].src} ${image.medium[0].width}w, ${image.large[1].src} ${image.large[1].width}w, ${image.large[0].src} ${image.large[0].width}w`,
                        alt: '',
                        sizes: '100%'
                        // width: image.width,
                        // height: image.height,
                        // placeholder: {
                        //     src: placeholderSrc,
                        //     // srcSet: `${placeholderSrc.replace('.jpg', '-m.jpg')} 438w, ${placeholderSrc} 875w, ${placeholderSrc.replace('.jpg', '@2x.jpg')} 1750w`,
                        //     srcSet: `${placeholderSrc.replace('.jpg', '-m.jpg')} 438w, ${placeholderSrc} 875w`
                        // }
                    };

                    if(index <= this.props.activeIndex) {
                        params.className += ' active';
                    }

                    if(index === 0 || index === 1) {
                        return <div key={`${this.props.projectPath}_${index}`}><img className={params.className} src={params.src} srcSet={params.srcSet} sizes={params.sizes} /></div>;
                    }
                    // return <LazyImage key={`${this.props.projectPath}_${index}`} ref={ref} attrs={params} onLoadCallback={this.onAssetLoadEnd.bind(this)} />
                    return <LazyImage key={`${this.props.projectPath}_${index}`} ref={ref} attrs={params} />
                })}
            </div>
        );
    }
};

export default WorkVisualsList;


// WEBPACK FOOTER //
// ./src/components/WorkVisualsList.js